import React, { useState, useEffect } from "react";
import RotationDisplay from "@components/VehicleDashboard/rotationDisplay/RotationDisplay.js";
import "./RotationDisplayArray.css";

import rollImage from "../../../images/dashboardLightsLogos/roll.svg";
import pitchImage from "../../../images/dashboardLightsLogos/pitch.svg";

export default function RotationDisplayArray({roll, pitch}) {

  const [vehicleRoll, setVehicleRoll] = useState(0);
  const [vehiclePitch, setVehiclePitch] = useState(0);

  // Use the useEffect hook to update the values every second
  useEffect(() => {
    const updateValues = () => {
      const randomRoll = parseFloat((Math.random() * 40 - 20).toFixed(2)); // Generate a random value between -20 and 20
      const randomPitch = parseFloat((Math.random() * 40 - 20).toFixed(2));
      setVehicleRoll(randomRoll);
      setVehiclePitch(randomPitch);
    };

    // Call the updateValues function every second
    const interval = setInterval(updateValues, 600);

    // Clean up the interval on component unmount
    return () => clearInterval(interval);
  }, []);

  return (
    <>
      <div className="row">
        <div className="col-md-6">
          <RotationDisplay angle={roll} label={"Roll"} imgSrc={rollImage} />
        </div>
        <div className="col-md-6">
          <RotationDisplay angle={pitch} label={"Pitch"} imgSrc={pitchImage} />
        </div>
      </div>
    </>
  );
}
